import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-8 bg-background-50">
      <div className="max-w-[1280px] mx-auto text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 mb-4">
          Gotowy na <span className="text-primary-500">Kakobuy Spreadsheet?</span>
        </h2>
        <p className="text-base text-foreground-500 max-w-lg mx-auto mb-8">
          Nie trać czasu na samodzielne szukanie. Skorzystaj z gotowej bazy produktów i znajdź najlepsze okazje w kilka sekund.
        </p>
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-foreground-950 text-background-50 text-base font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
        >
          kakobuy sheet
          <i className="ri-arrow-right-up-line text-lg"></i>
        </a>

        <div className="mt-16 relative w-full overflow-hidden">
          <div className="flex gap-6 justify-center flex-wrap">
            <div className="w-28 h-28 md:w-36 md:h-36 rounded-xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Colorful%20tie%20dye%20graphic%20print%20sweatshirt%20displayed%20on%20vintage%20wooden%20hanger%20against%20colorful%20graffiti%20wall%2C%20street%20art%20background%2C%20bright%20vibrant%20colors%2C%20bold%20artistic%20product%20photography&width=300&height=300&seq=cta-v2-01&orientation=squarish"
                alt="Produkt Kakobuy"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="w-28 h-28 md:w-36 md:h-36 rounded-xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Round%20tortoiseshell%20pattern%20retro%20sunglasses%20on%20striped%20beach%20towel%20with%20seashells%2C%20bright%20sunlight%2C%20vacation%20summer%20vibe%2C%20colorful%20pool%20toy%20in%20background%2C%20fun%20carefree%20lifestyle%20photography&width=300&height=300&seq=cta-v2-02&orientation=squarish"
                alt="Produkt Kakobuy"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="w-28 h-28 md:w-36 md:h-36 rounded-xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Chunky%20knitted%20mustard%20yellow%20beanie%20hat%20on%20snow%20covered%20wooden%20fence%2C%20winter%20mountain%20landscape%20out%20of%20focus%20in%20distance%2C%20crisp%20cold%20atmosphere%2C%20cozy%20winter%20accessories%20photography&width=300&height=300&seq=cta-v2-03&orientation=squarish"
                alt="Produkt Kakobuy"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="w-28 h-28 md:w-36 md:h-36 rounded-xl overflow-hidden bg-background-100 hidden md:block">
              <img
                src="https://readdy.ai/api/search-image?query=Classic%20round%20minimalist%20analog%20wristwatch%20with%20brown%20leather%20strap%20resting%20on%20open%20hardcover%20book%2C%20warm%20reading%20lamp%20glow%2C%20library%20bookshelf%20bokeh%20background%2C%20intellectual%20cozy%20aesthetic&width=300&height=300&seq=cta-v2-04&orientation=squarish"
                alt="Produkt Kakobuy"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="w-28 h-28 md:w-36 md:h-36 rounded-xl overflow-hidden bg-background-100 hidden lg:block">
              <img
                src="https://readdy.ai/api/search-image?query=Woven%20macrame%20fringed%20crossbody%20shoulder%20bag%20in%20terracotta%20orange%20color%20hanging%20on%20sunlit%20adobe%20wall%2C%20Mediterranean%20village%20architecture%2C%20bougainvillea%20flowers%20cascading%2C%20warm%20golden%20afternoon%20light%2C%20bohemian%20travel%20photography&width=300&height=300&seq=cta-v2-05&orientation=squarish"
                alt="Produkt Kakobuy"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}